// src/store/apiReducer.js
const initialState = {
  data: null,
  loading: false,
  error: null,
};

const apiReducer = (state = initialState, action) => {
  switch (action.type) {
    case "API_REQUEST":
      return { ...state, loading: true, error: null };
    case "API_SUCCESS":
      return { ...state, loading: false, data: action.payload.data };
    case "API_FAILURE":
      return { ...state, loading: false, error: action.payload.error };
    default:
      return state;
  }
};

export default apiReducer;
